import $ from "jquery";
import {
  initWorkParticipantStep,
} from "../cabinet/work-user-type-step";

function getEmbedPrefix() {
  const path = window.location.pathname;
  if (path.startsWith("/wb/") || path === "/wb") {
    return "/wb";
  }
  return "/frame";
}

function isWhiteLabelEmbedPath() {
  const path = window.location.pathname;
  return path.startsWith("/wb/") || path === "/wb";
}

function isVkFramePath() {
  const path = window.location.pathname || "";
  return path === "/frame" || path.startsWith("/frame/") || /^\/[a-z]{2}\/frame(\/|$)/.test(path);
}

const COFFEELIKE_METRIKA_ID = 112447837;
const COFFEELIKE_MAILRU_PIXEL_ID = "3793146";

function reachMailRuRegistrationGoal() {
  try {
    window._tmr = window._tmr || [];
    window._tmr.push({
      id: COFFEELIKE_MAILRU_PIXEL_ID,
      type: "reachGoal",
      goal: "registration",
    });
  } catch (e) {}
}

export function reachWbRegistrationGoal(onDone) {
  const finishOnce = (() => {
    let done = false;
    return () => {
      if (done) {
        return;
      }
      done = true;
      if (typeof onDone === "function") {
        onDone();
      }
    };
  })();

  if (isWhiteLabelEmbedPath()) {
    try {
      if (typeof window.ym === "function") {
        window.ym(COFFEELIKE_METRIKA_ID, "reachGoal", "registration", {}, finishOnce);
        window.setTimeout(finishOnce, 600);
        return;
      }
    } catch (e) {}
    finishOnce();
    return;
  }

  if (isVkFramePath()) {
    reachMailRuRegistrationGoal();
    window.setTimeout(finishOnce, 400);
    return;
  }

  finishOnce();
}

const FOREIGN_EMAIL_DENIED_MESSAGE =
  "В соответствии с Федеральным законом от 31.07.2023 № 406-ФЗ регистрация с использованием иностранных адресов электронной почты невозможна. Пожалуйста, используйте другой адрес почты.";

const PROTON_EMAIL_DENIED_MESSAGE =
  "Регистрация с использованием адресов Proton Mail невозможна. Пожалуйста, используйте другой адрес почты.";

const DENIED_EMAIL_DOMAINS = [
  "gmail.com",
  "yahoo.com",
  "bing.com",
  "outlook.com",
  "icloud.com",
];

const PROTON_EMAIL_DOMAINS = [
  "protonmail.com",
  "protonmail.ch",
  "proton.me",
  "pm.me",
];

const RESEND_COOLDOWN_SEC = 59;

const isForeignEmailDenied = (email) => {
  const parts = String(email || "").toLowerCase().split("@");
  if (parts.length !== 2) {
    return false;
  }

  return DENIED_EMAIL_DOMAINS.includes(parts[1]);
};

const isForceNewWork = () => $("input[name='new'][value='1']").length > 0;

const appendForceNewWorkData = (data) => {
  if (isForceNewWork()) {
    data.new = 1;
  }

  return data;
};

const isProtonEmailDenied = (email) => {
  const parts = String(email || "").toLowerCase().split("@");
  if (parts.length !== 2) {
    return false;
  }

  return PROTON_EMAIL_DOMAINS.includes(parts[1]);
};

const getEmbedEmailDeniedMessage = (email) => {
  if (isForeignEmailDenied(email)) {
    return FOREIGN_EMAIL_DENIED_MESSAGE;
  }
  if (isWhiteLabelEmbedPath() && isProtonEmailDenied(email)) {
    return PROTON_EMAIL_DENIED_MESSAGE;
  }

  return null;
};

function isVkMiniAppEmbed() {
  if (isWhiteLabelEmbedPath()) {
    return false;
  }
  if (isVkFramePath()) {
    return true;
  }
  try {
    if (window.sessionStorage.getItem("wbEmbedVk") === "1") {
      return true;
    }
  } catch (e) {}
  const search = String(window.location.search || "");
  const hash = String(window.location.hash || "");
  if (/[?&#]vk_/.test(search) || /[?&#]vk_/.test(hash)) {
    return true;
  }
  if (/VKAndroidApp|VKiOSApp|com\.vk\.vkclient/i.test(navigator.userAgent || "")) {
    return true;
  }
  try {
    if (document.referrer && /(?:^|\.)vk\.(com|ru)\b/i.test(document.referrer)) {
      return true;
    }
  } catch (e) {}
  return false;
}

export function applyWbEmbedViewport() {
  if (!document.body.classList.contains("wb-embed")) {
    return;
  }
  if (isVkMiniAppEmbed()) {
    document.documentElement.classList.add("wb-embed-vk");
    document.body.classList.add("wb-embed--vk");
    try {
      window.sessionStorage.setItem("wbEmbedVk", "1");
    } catch (e) {}
    const isMobile = window.matchMedia("(max-width: 767px)").matches;
    const spacerStyle = isMobile
      ? "display:block;width:100%;height:72px;min-height:72px;margin:0;padding:0;background:#fff;flex-shrink:0;"
      : "display:none;width:100%;height:0;min-height:0;margin:0;padding:0;overflow:hidden;";
    let spacer = document.querySelector(".wb-vk-clock-spacer");
    if (!spacer) {
      spacer = document.createElement("div");
      spacer.className = "wb-vk-clock-spacer";
      spacer.setAttribute("aria-hidden", "true");
      document.body.insertBefore(spacer, document.body.firstChild);
    }
    spacer.setAttribute("style", spacerStyle);
  }
}

/**
 * Свернуть common_footer до логотипа: скрываем всё без .frame-visible (см. partial).
 * Нужен и на /frame/.../ заявке: там подключается cabinet.js (без app.js), поэтому вызывать
 * с cabinet.js. На витрине — из initFrameWork.
 */
export function applyFrameFooterCompact() {
  applyWbEmbedViewport();
  const path = window.location.pathname;
  const embedPrefix = getEmbedPrefix();
  const isVkFrameWorkPage = new RegExp(
    `^${embedPrefix}/contests/[^/]+/gallery/[^/]+$`
  ).test(path);
  const isFrameByPath = path.startsWith(embedPrefix + "/");
  const frameHeader = $(".frame-header");
  if (!frameHeader.length && !isVkFrameWorkPage && !isFrameByPath) {
    return;
  }
  $(".button-support").addClass("hidden");
  const footer = $(".block-footer");
  if (!footer.length) {
    return;
  }
  if (isWhiteLabelEmbedPath() || document.body.classList.contains("wb-embed")) {
    footer.hide();
    return;
  }
  footer.find("*").not(".frame-visible").each(function () {
    this.style.setProperty("display", "none", "important");
  });
  footer.find(".block-footer-logo").css("padding-bottom", "50px");
  footer.find(".block-footer-link").removeAttr("href");
}

function isWbEmbedStep4Page() {
  return Boolean(
    document.querySelector(
      "#wb-publish-form, .wb-step4-actions, .wb-step4-consent, #contest_work_consent"
    )
  );
}

function getWbStepLoader() {
  return document.getElementById("wb-step-loader");
}

let wbStepLoaderHideTimer = null;
const WB_STEP_LOADER_MAX_MS = 3000;

export function showWbStepLoader() {
  if (isWbEmbedStep4Page()) {
    return;
  }
  const loader = getWbStepLoader();
  if (!loader) {
    return;
  }
  loader.classList.remove("hidden");
  loader.removeAttribute("hidden");
  loader.setAttribute("aria-hidden", "false");
  if (wbStepLoaderHideTimer) {
    window.clearTimeout(wbStepLoaderHideTimer);
  }
  wbStepLoaderHideTimer = window.setTimeout(() => {
    hideWbStepLoader();
  }, WB_STEP_LOADER_MAX_MS);
}

export function hideWbStepLoader() {
  if (wbStepLoaderHideTimer) {
    window.clearTimeout(wbStepLoaderHideTimer);
    wbStepLoaderHideTimer = null;
  }
  const loader = getWbStepLoader();
  if (!loader) {
    return;
  }
  loader.classList.add("hidden");
  loader.setAttribute("hidden", "");
  loader.setAttribute("aria-hidden", "true");
}

function isSafeHttpUrl(href) {
  if (!href) {
    return false;
  }
  if (href.startsWith("#") || href.startsWith("javascript:")) {
    return false;
  }
  return true;
}

function initWbStepLoader() {
  window.__showWbStepLoader = showWbStepLoader;
  window.__hideWbStepLoader = hideWbStepLoader;

  if (window.__wbStepLoaderBound) {
    return;
  }
  window.__wbStepLoaderBound = true;

  if (!getWbStepLoader()) {
    return;
  }

  document.addEventListener("click", (event) => {
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
      return;
    }

    if (event.target.closest("input, textarea, select, label, .form-check, .wb-step4-consent, #contest_work_consent, .wb-step4-actions")) {
      return;
    }

    const saveBtn = event.target.closest(".block-publication-contest-work-save");
    if (saveBtn && !saveBtn.disabled && !saveBtn.classList.contains("submit-work-not-allowed")) {
      showWbStepLoader();
      return;
    }

    const link = event.target.closest(
      ".wb-stepper a[href], .wb-form-footer__back[href], .wb-shell__back[href], .wb-form-footer a[href]"
    );
    if (!link) {
      return;
    }
    if (link.target === "_blank") {
      return;
    }
    if (!isSafeHttpUrl(link.getAttribute("href") || "")) {
      return;
    }
    showWbStepLoader();
  });

  document.addEventListener("submit", (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || event.defaultPrevented) {
      return;
    }
    if (form.target === "_blank") {
      return;
    }
    if (form.id === "wb-publish-form" || form.closest(".wb-step4-actions") || isWbEmbedStep4Page()) {
      return;
    }
    if (form.id === "wb-archive-modal-form") {
      showWbStepLoader();
      return;
    }
    if (form.closest("#frame-public-vote-auth, .iframe-work-code__block, .wb-archive-modal")) {
      return;
    }
    if (
      form.closest(".wb-embed-step-area, .wb-shell, .wb-applications-page, .iframe-work-email-step")
      || (document.body.classList.contains("wb-embed") && form.closest(".cabinet-grid"))
    ) {
      showWbStepLoader();
    }
  });
}

export default function initFrameWork() {
  applyWbEmbedViewport();
  initWbStepLoader();

  if (window.__competizerIframeWorkBound) {
    return;
  }

  if (document.querySelector(".wb-applications-page")) {
    return;
  }

  applyFrameFooterCompact();

  const isWbAuthFlow = $("#wb-auth-step-email").length > 0;
  const embedPrefix = getEmbedPrefix();
  const checkCodeUrl = window.wbEmbedConfig?.checkCodeUrl || `${embedPrefix}/check-code`;
  const checkEmailUrl = window.wbEmbedConfig?.checkEmailUrl || `${embedPrefix}/check-email`;
  const overlay = $("#iframe-work-code-overlay");
  const iframeModal = overlay.closest(".iframe-work-code__block");
  const isWbEmbedShell = document.body.classList.contains('wb-embed');
  const frameStepButton = $("form.form button.frame-step-1");
  const submitButton = isWbAuthFlow
    ? $("#wb-auth-code-submit")
    : iframeModal.find(".iframe-work-code-block__submit");
  const codeInput = isWbAuthFlow
    ? $("#wb-auth-step-code .iframe-work-code-block__input")
    : iframeModal.find(".iframe-work-code-block__input");
  const hiddenEmail = $(".iframe-work-code-block__hidden-email");
  const basicEmail = $("form.form input[name='email']");
  const incorrectCode = isWbAuthFlow
    ? $("#wb-code-status")
    : iframeModal.find(".iframe-code__incorrect");
  const workInput = $("[name='work_hash_id']");
  const contestInput = $("[name='contest_hash_id']");
  const codeSended = iframeModal.find(".iframe-code__sended");
  const step1ConfirmButton = $(".block-publication-contest-work-save");
  const frameEmailStatus = $("#frame-email-status");
  const emailInput = $("form.form .form__input#email");
  const resendButton = isWbAuthFlow
    ? $("#wb-auth-resend")
    : iframeModal.find(".iframe-work-code-block__resend");
  const wbEmailStep = $("#wb-auth-step-email");
  const wbCodeStep = $("#wb-auth-step-code");
  const wbCodeCells = wbCodeStep.find(".wb-code-inputs__cell");
  const wbChangeEmailButton = $("#wb-auth-change-email");
  const consentCheckbox = $("input[name='wb_terms_consent']");
  const resendTimerEl = $("#wb-auth-resend-timer");
  const emailStepMarker = $(".iframe-work-email-step");
  const wbAuthTarget = emailStepMarker.attr("data-wb-auth-target") || "work";
  const isWbApplicationsAuth = isWbAuthFlow && wbAuthTarget === "applications";
  const isContestScopedEmail = emailStepMarker.attr("data-is-contest-scoped-email") === "1";

  const hasModalFlow = iframeModal.length && overlay.length;
  if (!frameStepButton.length || !submitButton.length || !codeInput.length) {
    return;
  }
  if (!isWbAuthFlow && !hasModalFlow) {
    return;
  }

  window.__competizerIframeWorkBound = true;
  let sendCodeRequest = null;
  let resendTimerId = null;
  let resendSecondsLeft = 0;

  const cleanEmail = (email) => email.replace(/\+[^@]*/g, "");

  const decodeHtmlEntities = (value) => {
    const node = document.createElement("textarea");
    node.innerHTML = String(value || "");
    return node.value;
  };

  const normalizeEmailDisplay = (email) => decodeHtmlEntities(cleanEmail(String(email || "")));

  const validateEmail = (email) => {
    if (email.length > 64) {
      return false;
    }
    if (getEmbedEmailDeniedMessage(email)) {
      return false;
    }
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
  };

  const showEmailError = (message) => {
    frameEmailStatus.html(message);
    frameEmailStatus.removeClass("iframe-input__green");
    frameEmailStatus.addClass("iframe-input__red");
    frameEmailStatus.removeClass("hidden");
  };

  const showCodeError = (message) => {
    if (!isWbAuthFlow) {
      incorrectCode.html(message);
      incorrectCode.removeClass("hidden");
      return;
    }

    incorrectCode.html(message);
    incorrectCode.removeClass("iframe-input__green hidden");
    incorrectCode.addClass("iframe-input__red");
    wbCodeCells.addClass("wb-code-inputs__cell--error");
  };

  const clearCodeError = () => {
    if (isWbAuthFlow) {
      incorrectCode.addClass("hidden");
      incorrectCode.removeClass("iframe-input__red iframe-input__green");
      wbCodeCells.removeClass("wb-code-inputs__cell--error");
      return;
    }

    incorrectCode.addClass("hidden");
  };

  const showDeniedEmailError = (email) => {
    showEmailError(getEmbedEmailDeniedMessage(email) || FOREIGN_EMAIL_DENIED_MESSAGE);
  };

  const getCurrentEmail = () => normalizeEmailDisplay(basicEmail.val() || hiddenEmail.val() || "");

  const syncHiddenEmail = (email) => {
    const normalizedEmail = normalizeEmailDisplay(email);
    hiddenEmail.val(normalizedEmail);
    if (isWbAuthFlow) {
      wbCodeStep.find(".wb-auth-code-email").text(normalizedEmail);
    }
  };

  const getCodeValue = () => {
    if (isWbAuthFlow && wbCodeCells.length) {
      return wbCodeCells.toArray().map((cell) => String(cell.value || "").replace(/\D/g, "")).join("").slice(0, 6);
    }

    return String(codeInput.val() || "").replace(/\D/g, "").slice(0, 6);
  };

  const setCodeValue = (value) => {
    const digits = String(value || "").replace(/\D/g, "").slice(0, 6);
    codeInput.val(digits);

    if (isWbAuthFlow && wbCodeCells.length) {
      wbCodeCells.each(function (index) {
        this.value = digits[index] || "";
      });
    }

    updateSubmitState();
  };

  const updateSubmitState = () => {
    const complete = getCodeValue().length === 6;
    if (complete) {
      submitButton.removeAttr("disabled");
    } else {
      submitButton.attr("disabled", "disabled");
    }
  };

  const formatResendTimer = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${String(secs).padStart(2, "0")}`;
  };

  const stopResendTimer = () => {
    if (resendTimerId) {
      window.clearInterval(resendTimerId);
      resendTimerId = null;
    }
  };

  const updateResendButton = () => {
    if (!isWbAuthFlow || !resendButton.length) {
      return;
    }

    if (resendSecondsLeft > 0) {
      resendButton.attr("disabled", "disabled");
      resendTimerEl.text(formatResendTimer(resendSecondsLeft));
      return;
    }

    resendButton.removeAttr("disabled");
    resendButton.text("Отправить код повторно");
  };

  const startResendTimer = () => {
    if (!isWbAuthFlow) {
      return;
    }

    stopResendTimer();
    resendSecondsLeft = RESEND_COOLDOWN_SEC;
    updateResendButton();

    resendTimerId = window.setInterval(() => {
      resendSecondsLeft -= 1;
      if (resendSecondsLeft <= 0) {
        stopResendTimer();
        resendSecondsLeft = 0;
      }
      updateResendButton();
    }, 1000);
  };

  const showWbEmailStep = () => {
    wbEmailStep.removeClass("hidden");
    wbCodeStep.addClass("hidden");
    stopResendTimer();
    clearCodeError();
    frameStepButton.removeClass("hidden");
    step1ConfirmButton.css("display", "none");
  };

  const showWbCodeStep = (email) => {
    syncHiddenEmail(email);
    wbEmailStep.addClass("hidden");
    wbCodeStep.removeClass("hidden");
    setCodeValue("");
    clearCodeError();
    startResendTimer();
    if (wbCodeCells.length) {
      wbCodeCells.first().trigger("focus");
    }
  };

  const getCheckEmailPayload = (email, code = "") => {
    const payload = appendForceNewWorkData({
      email,
      code,
      work: workInput.val(),
      contest: contestInput.val(),
      contest_hash_id: contestInput.val(),
    });

    if (isWbApplicationsAuth) {
      payload.context = "applications";
    }

    return payload;
  };

  const redirectToWbApplicationsList = (response) => {
    if (response?.redirect_url) {
      showWbStepLoader();
      window.location.href = response.redirect_url;
      return true;
    }

    if (
      response?.has_existing_works === false
      && response?.new_work_url
      && !isForceNewWork()
    ) {
      showWbStepLoader();
      window.location.href = response.new_work_url;
      return true;
    }

    const listUrl = response?.applications_list_url
      || $("#wb-my-applications-link-email-step").attr("href")
      || $("#wb-my-applications-link").attr("href");

    if (listUrl) {
      showWbStepLoader();
      window.location.href = listUrl;
      return true;
    }

    return false;
  };

  const followWbEmailVerifiedRedirect = (response) => {
    if (response?.redirect_url) {
      showWbStepLoader();
      window.location.href = response.redirect_url;
      return true;
    }

    if (isWbApplicationsAuth && redirectToWbApplicationsList(response)) {
      return true;
    }

    if (
      isWhiteLabelEmbedPath()
      && response?.redirect_to_cabinet
      && response.applications_list_url
      && !isForceNewWork()
    ) {
      showWbStepLoader();
      window.location.href = response.applications_list_url;
      return true;
    }

    if (
      isWhiteLabelEmbedPath()
      && response?.has_existing_works === false
      && response?.new_work_url
      && !isForceNewWork()
    ) {
      showWbStepLoader();
      window.location.href = response.new_work_url;
      return true;
    }

    return false;
  };

  const handleSendCodeResponse = (response, onSuccess) => {
    if (
      response?.status === "error"
      && (response.message === "foreign_email_denied" || response.message === "proton_email_denied")
    ) {
      showDeniedEmailError(getCurrentEmail());
      return;
    }

    if (response?.status === "error" && response.message === "mail_failed") {
      showEmailError("Не удалось отправить код на указанный email. Попробуйте позже.");
      return;
    }

    if (response?.already_confirmed) {
      verifyWbEmailAccess(getCurrentEmail());
      return;
    }

    if (response?.status !== "ok") {
      showEmailError("Не удалось отправить код. Попробуйте позже.");
      return;
    }

    if (typeof onSuccess === "function") {
      onSuccess(response);
    }
  };

  const showWbMyApplicationsLink = (listUrl) => {
    if (!isWhiteLabelEmbedPath()) {
      return;
    }

    const url = listUrl || $("#wb-my-applications-link-email-step").attr("href") || $("#wb-my-applications-link").attr("href");

    $("#wb-my-applications-link-wrap").removeClass("hidden");

    if (url) {
      $("#wb-my-applications-link-email-step, #wb-my-applications-link").attr("href", url);
    }
  };

  const submitEmailFormAfterVerification = () => {
    const formEl = emailStepMarker.closest("form")[0];

    if (!formEl) {
      return false;
    }

    const email = getCurrentEmail();
    const emailField = formEl.querySelector('[name="email"]');

    if (emailField) {
      emailField.value = email;
    }

    syncHiddenEmail(email);

    if (typeof formEl.requestSubmit === "function") {
      formEl.requestSubmit();
    } else {
      formEl.submit();
    }

    return true;
  };

  const advanceAfterEmailVerification = (response) => {
    if (isContestScopedEmail && submitEmailFormAfterVerification()) {
      return;
    }

    if (followWbEmailVerifiedRedirect(response)) {
      return;
    }

    if (isWbAuthFlow && submitEmailFormAfterVerification()) {
      return;
    }

    showEmailConfirmedContinue();
    showWbMyApplicationsLink(response?.applications_list_url);
    initWorkParticipantStep();
    resetForm();
  };

  const verifyWbEmailAccess = (email) => {
    $.ajax({
      type: "POST",
      url: checkEmailUrl,
      dataType: "json",
      data: getCheckEmailPayload(email),
      success(response) {
        advanceAfterEmailVerification(response);
      },
      error() {
        showEmailError("Не удалось проверить email. Нажмите «Отправить код», чтобы продолжить.");
      },
    });
  };

  const showEmailConfirmedContinue = () => {
    if (isWbApplicationsAuth || isContestScopedEmail) {
      return;
    }

    if (isWbAuthFlow) {
      wbCodeStep.addClass("hidden");
      wbEmailStep.removeClass("hidden");
      stopResendTimer();
      clearCodeError();
    }

    frameEmailStatus.html("Адрес электронной почты подтвержден!");
    frameEmailStatus.removeClass("iframe-input__red");
    frameEmailStatus.addClass("iframe-input__green");
    frameEmailStatus.removeClass("hidden");
    frameStepButton.addClass("hidden");
    step1ConfirmButton.css("display", "flex");
    showWbMyApplicationsLink();
  };

  const proceedAfterCodeRequest = (response) => {
    if (response?.already_confirmed) {
      verifyWbEmailAccess(getCurrentEmail());
      return;
    }

    if (response?.status !== "ok") {
      showEmailError("Не удалось отправить код. Попробуйте позже.");
      return;
    }

    if (response?.status === 404 && step1ConfirmButton.length) {
      step1ConfirmButton.trigger("click");
      return;
    }

    if (isWbAuthFlow) {
      showWbCodeStep(getCurrentEmail());
      return;
    }

    iframeModal.removeClass("hidden");
    if (!isWbEmbedShell) {
      overlay.fadeIn();
    }
    resetForm();
  };

  if (emailStepMarker.attr("data-confirm-code-is-live") === "1") {
    const presetEmail = getCurrentEmail();
    if (validateEmail(presetEmail)) {
      if (isWbApplicationsAuth) {
        verifyWbEmailAccess(presetEmail);
      } else if (isForceNewWork()) {
        showEmailConfirmedContinue();
      } else {
        verifyWbEmailAccess(presetEmail);
      }
    }
  }

  const clearEmailStatus = () => {
    frameEmailStatus.html("");
    frameEmailStatus.removeClass("iframe-input__red");
    frameEmailStatus.removeClass("iframe-input__green");
    frameEmailStatus.addClass("hidden");
  };

  let attemptCount = 0;
  const MAX_ATTEMPTS = 5;
  const RESET_DELAY = 3000;

  const updateIncorrectMessage = () => {
    const attemptsLeft = MAX_ATTEMPTS - attemptCount;
    showCodeError(`Неверный код (осталось попыток: ${attemptsLeft})`);
  };

  const sendNewCode = (email, { resend = false } = {}) => {
    if (sendCodeRequest && !resend) {
      return sendCodeRequest;
    }

    const payload = { email };
    if (resend) {
      payload.resend = 1;
    }

    const contestHashId = contestInput.val();
    if (contestHashId) {
      payload.contest_hash_id = contestHashId;
      payload.contest = contestHashId;
    }

    sendCodeRequest = $.ajax({
      type: "POST",
      url: checkCodeUrl,
      dataType: "json",
      data: payload,
    }).always(() => {
      sendCodeRequest = null;
    });

    return sendCodeRequest;
  };

  const resetForm = () => {
    attemptCount = 0;
    setCodeValue("");
    clearCodeError();
    if (!isWbAuthFlow) {
      codeSended.removeClass("hidden");
      incorrectCode.html("Неверный код");
    }
  };

  const handleCodeResend = () => {
    if (isWbAuthFlow && resendSecondsLeft > 0) {
      return;
    }

    const email = getCurrentEmail();

    if (!validateEmail(email) || email.includes("+")) {
      const deniedMessage = getEmbedEmailDeniedMessage(email);
      if (deniedMessage) {
        if (isWbAuthFlow) {
          showWbEmailStep();
        }
        showEmailError(deniedMessage);
      } else {
        showEmailError("Введите корректный email адрес");
      }
      return;
    }

    setCodeValue("");
    clearCodeError();

    sendNewCode(email, { resend: true }).then((response) => {
      handleSendCodeResponse(response, () => {
        if (isWbAuthFlow) {
          showCodeError("Новый код отправлен на вашу почту");
          incorrectCode.removeClass("iframe-input__red");
          incorrectCode.addClass("iframe-input__green");
          startResendTimer();
        } else {
          incorrectCode.html("Новый код отправлен на вашу почту");
          incorrectCode.removeClass("hidden");
          codeSended.addClass("hidden");
        }
        attemptCount = 0;
      });
    }).fail(() => {
      showCodeError("Не удалось отправить код. Попробуйте позже.");
    });
  };

  const submitCode = () => {
    const code = getCodeValue();
    const email = getCurrentEmail();
    const work = workInput.val();
    const contest = contestInput.val();

    const deniedMessage = getEmbedEmailDeniedMessage(email);
    if (deniedMessage) {
      if (isWbAuthFlow) {
        showWbEmailStep();
      }
      showEmailError(deniedMessage);
      return;
    }

    if (!validateEmail(email)) {
      showEmailError("Введите корректный email адрес");
      return;
    }

    if (code.length !== 6) {
      showCodeError("Введите 6-значный код из письма");
      return;
    }

    if (attemptCount >= MAX_ATTEMPTS) {
      return;
    }

    submitButton.attr("disabled", "disabled");

    $.ajax({
      type: "POST",
      url: checkEmailUrl,
      dataType: "json",
      data: getCheckEmailPayload(email, code),
      success(response) {
        if (
          response.status === "error"
          && (response.message === "foreign_email_denied" || response.message === "proton_email_denied")
        ) {
          showDeniedEmailError(email);
          updateSubmitState();
          return;
        }

        if (response.status === "success" && response.message === true) {
          if (!isWbAuthFlow) {
            if (!isWbEmbedShell) {
              overlay.fadeOut();
            }
            iframeModal.addClass("hidden");
          }

          reachWbRegistrationGoal(() => {
            advanceAfterEmailVerification(response);
          });
          return;
        }

        attemptCount += 1;
        updateSubmitState();

        if (attemptCount >= MAX_ATTEMPTS) {
          showCodeError("Превышен лимит попыток. Новый код отправлен на вашу почту.");

          sendNewCode(email, { resend: true }).then((response) => {
            handleSendCodeResponse(response, () => {
              if (isWbAuthFlow) {
                startResendTimer();
              }
              setTimeout(resetForm, RESET_DELAY);
            });
          });
        } else {
          updateIncorrectMessage();
        }
      },
      error() {
        showCodeError("Не удалось проверить код. Попробуйте позже.");
        updateSubmitState();
      },
    });
  };

  resendButton.off("click.iframeWorkCode").on("click.iframeWorkCode", (e) => {
    e.preventDefault();
    handleCodeResend();
  });

  if (!isWbAuthFlow) {
    overlay.off("click.iframeWorkCode").on("click.iframeWorkCode", () => {
      iframeModal.addClass("hidden");
      if (!isWbEmbedShell) {
        overlay.fadeOut();
      }
      resetForm();
    });
  }

  wbChangeEmailButton.off("click.iframeWorkCode").on("click.iframeWorkCode", (e) => {
    e.preventDefault();
    showWbEmailStep();
    resetForm();
    clearEmailStatus();
  });

  frameStepButton.off("click.iframeWorkCode").on("click.iframeWorkCode", (e) => {
    e.preventDefault();
    if (frameStepButton.prop("disabled")) {
      return;
    }

    const email = getCurrentEmail();

    if (isWbAuthFlow && consentCheckbox.length && !consentCheckbox.is(":checked")) {
      showEmailError(
        consentCheckbox.attr("data-consent-error") ||
          "Необходимо согласиться с условиями конкурса"
      );
      return;
    }

    const deniedMessage = getEmbedEmailDeniedMessage(email);
    if (deniedMessage) {
      showEmailError(deniedMessage);
      return;
    }

    if (!validateEmail(email)) {
      showEmailError("Введите корректный email адрес");
      return;
    }

    syncHiddenEmail(email);
    frameStepButton.prop("disabled", true);

    sendNewCode(email).then((response) => {
      handleSendCodeResponse(response, () => {
        proceedAfterCodeRequest(response);
      });
    }).fail(() => {
      showEmailError("Не удалось отправить код. Проверьте соединение и попробуйте снова.");
    }).always(() => {
      frameStepButton.prop("disabled", false);
    });
  });

  emailInput.off("input.iframeWorkCode").on("input.iframeWorkCode", function () {
    let email = $(this).val();
    const cleanedEmail = cleanEmail(email);
    if (email !== cleanedEmail) {
      $(this).val(cleanedEmail);
      email = cleanedEmail;
    }

    if (validateEmail(email)) {
      clearEmailStatus();
    } else if (email.length > 0) {
      const deniedMessage = getEmbedEmailDeniedMessage(email);
      if (deniedMessage) {
        showEmailError(deniedMessage);
      } else {
        showEmailError("Введите корректный email адрес");
      }
    } else {
      clearEmailStatus();
    }
  });

  if (isWbAuthFlow && wbCodeCells.length) {
    wbCodeCells.off("input.iframeWorkCode").on("input.iframeWorkCode", function () {
      const $cell = $(this);
      const index = wbCodeCells.index(this);
      let digit = String(this.value || "").replace(/\D/g, "").slice(-1);
      this.value = digit;
      clearCodeError();

      if (digit && index < wbCodeCells.length - 1) {
        wbCodeCells.eq(index + 1).trigger("focus");
      }

      codeInput.val(getCodeValue());
      updateSubmitState();
    });

    wbCodeCells.off("keydown.iframeWorkCode").on("keydown.iframeWorkCode", function (e) {
      const index = wbCodeCells.index(this);

      if (e.key === "Backspace" && !this.value && index > 0) {
        wbCodeCells.eq(index - 1).trigger("focus");
      }
    });

    wbCodeCells.off("paste.iframeWorkCode").on("paste.iframeWorkCode", (e) => {
      e.preventDefault();
      const pasted = (e.originalEvent?.clipboardData?.getData("text") || "").replace(/\D/g, "").slice(0, 6);
      setCodeValue(pasted);
      clearCodeError();
      if (pasted.length === 6) {
        submitButton.trigger("focus");
      }
    });
  } else {
    codeInput.off("input.iframeWorkCode").on("input.iframeWorkCode", function () {
      codeInput.removeClass("iframe-input__red");
      codeSended.addClass("hidden");
      clearCodeError();
      updateSubmitState();
    });
  }

  submitButton.off("click.iframeWorkCode").on("click.iframeWorkCode", (e) => {
    e.preventDefault();
    submitCode();
  });
}
